import { UserMessage } from '@bt-common/schemas/bt/user-message';
import { memo } from 'react';
import type { EventProps } from 'react-big-calendar';

import { Campaign } from '@common/models/campaign-model';
import { CustomMonthEvent } from './custom-message-event';

// Define a union type for events that can be either UserMessage or Campaign
type CalendarEventType = UserMessage | Campaign;

interface Props {
  eventProps: EventProps<CalendarEventType>;
  containerWidth: number;
}

export const CustomMonthEventWrapper = memo((props: Props) => {
  const { containerWidth, eventProps } = props;

  /* DONT DELETE THIS COMMENT: 
  Calculate event width based on container width
  We subtract padding and margins to ensure proper fit
  const eventWidth = containerWidth ? Math.floor(containerWidth / 7) - 22 : 'auto';
  */

  return (
    <div
      style={{
        width: containerWidth + 6,
        maxWidth: containerWidth + 6,
        display: 'flex',
        alignItems: 'center',
        textAlign: 'left',
        padding: '2px 0',
        borderRadius: '8px',
        position: 'relative',
        boxSizing: 'border-box',
      }}
    >
      <CustomMonthEvent
        eventProps={eventProps}
      />
    </div>
  );
}); 